@use "variables" as *;

.description {
  font-size: $fontSize-m;
  margin-bottom: $spacing-s;
}

.cancelButton {
  color: indianred;
}

.textField {
  height: 60px;
}
